import React from 'react';
import { realValues, isCategorizedSkills, splitSkill, validCerts, certMeta } from './contactUtils';

export default function ClassicTemplate({ resume }) {
  if (!resume) return null;
  const c = resume.contact || {};

  return (
    <div style={{ fontFamily: 'Georgia, "Times New Roman", serif', maxWidth: '680px', margin: '0 auto', padding: '32px 36px', fontSize: '11px', lineHeight: '1.5', color: '#111', background: '#fff' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', borderBottom: '2px solid #111', paddingBottom: '10px', marginBottom: '12px' }}>
        <div style={{ fontSize: '22px', fontWeight: 'bold', letterSpacing: '1px', marginBottom: '4px' }}>{c.name}</div>
        <div style={{ fontSize: '9.5px', color: '#333' }}>
          {realValues([c.email, c.phone, c.location, c.linkedin]).join('  |  ')}
        </div>
      </div>

      {/* Summary */}
      {resume.summary && (
        <Section title="PROFESSIONAL SUMMARY">
          <p style={{ margin: 0, textAlign: 'justify' }}>{resume.summary}</p>
        </Section>
      )}

      {/* Skills */}
      {resume.skills?.length > 0 && (
        <Section title="SKILLS">
          {isCategorizedSkills(resume.skills) ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
              {resume.skills.map((s, i) => {
                const { label, rest } = splitSkill(s);
                return <div key={i}>{label ? <><strong>{label}:</strong> {rest}</> : <>•&nbsp;{s}</>}</div>;
              })}
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', columnGap: '14px', rowGap: '2px' }}>
              {resume.skills.map((s, i) => <span key={i}>•&nbsp;{s}</span>)}
            </div>
          )}
        </Section>
      )}

      {/* Experience */}
      {resume.experience?.length > 0 && (
        <Section title="EXPERIENCE">
          {resume.experience.map((exp, i) => (
            <div key={i} style={{ marginBottom: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '11px' }}>
                <span>{exp.company}</span>
                <span style={{ fontWeight: 'normal', color: '#444' }}>{exp.dates}</span>
              </div>
              <div style={{ fontStyle: 'italic', color: '#444', marginBottom: '4px' }}>{exp.title}</div>
              <ul style={{ margin: '0', paddingLeft: '16px' }}>
                {exp.bullets?.map((b, j) => <li key={j} style={{ marginBottom: '2px' }}>{b}</li>)}
              </ul>
            </div>
          ))}
        </Section>
      )}

      {/* Education */}
      {resume.education?.length > 0 && (
        <Section title="EDUCATION">
          {resume.education.map((edu, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
              <div>
                <span style={{ fontWeight: 'bold' }}>{edu.institution}</span>
                <span style={{ color: '#444' }}>  —  {edu.degree}</span>
              </div>
              <span style={{ color: '#444' }}>{edu.dates}</span>
            </div>
          ))}
        </Section>
      )}

      {/* Certifications */}
      {validCerts(resume).length > 0 && (
        <Section title="CERTIFICATIONS">
          {validCerts(resume).map((cert, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
              <span style={{ fontWeight: 'bold' }}>{cert.name}</span>
              <span style={{ color: '#444' }}>{certMeta(cert)}</span>
            </div>
          ))}
        </Section>
      )}
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '12px' }}>
      <div style={{ fontWeight: 'bold', fontSize: '11px', letterSpacing: '0.8px', borderBottom: '1px solid #999', paddingBottom: '2px', marginBottom: '6px' }}>{title}</div>
      {children}
    </div>
  );
}
